import { useNavigate } from "react-router-dom";

import { SkinBalance } from "../components/SkinBalance";
import { usePersonalisationData } from "../context/PersonalisationDataContext";
import { usePersonalisationLeave } from "../context/PersonalisationLeaveContext";

import { PreparingScreenContainer_PATH } from "./PreparingScreenContainer";
import { SkinSunContainer_PATH } from "./SkinSunContainer";

export const SkinBalanceContainer_PATH = "/personalise/skin-balance" as const;

export const SkinBalanceContainer = () => {
  const navigate = useNavigate();
  const { skinBalance, setSkinBalanceAnswered, skipSkinBalance } = usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();
  return (
    <SkinBalance
      progressPercentage={85}
      initialSelectedId={skinBalance.state === "answered" ? skinBalance.value : null}
      onContinue={(selection) => {
        setSkinBalanceAnswered(selection);
        navigate(PreparingScreenContainer_PATH);
      }}
      onSkip={() => {
        skipSkinBalance();
        navigate(PreparingScreenContainer_PATH);
      }}
      onBack={() => navigate(SkinSunContainer_PATH)}
      onClose={openConfirmLeave}
    />
  );
};
